import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { BehaviorSubject } from "rxjs";
import { ApiModuleMapConstants } from "../../shared/constants/api-constants/api-module-map.constants";
import { MapServiceConstants } from "../../shared/constants/map-service.constants";
let MapServiceService = class MapServiceService {
    http;
    moduleIdFilter = MapServiceConstants.MODULE_ID_FILTER_STRING;
    layerUrlList = new BehaviorSubject(null);
    layerUrlListAsObservable = this.layerUrlList.asObservable();
    mapConfigURL = ApiModuleMapConstants.URL;
    constructor(http) {
        this.http = http;
    }
    setPropertyMapLayers(urlList) {
        this.layerUrlList.next(urlList);
    }
    getMaps(moduleId, tableItems) {
        const params = {
            $filter: this.moduleIdFilter + moduleId,
            $orderby: "name"
        };
        return this.http.get(`${ApiModuleMapConstants.URL}/${ApiModuleMapConstants.FUNCTION_GET_MODULE_MAP_FOR_AFLA_PORTAL}`, { params }).pipe(map((response) => {
            Object.keys(response.value).forEach((element) => {
                if (!response.value[element].authType) {
                    response.value[element].authType = "None";
                }
                const attachmentLabel = response.value[element].url;
                response.value[element].urlLink = {
                    text: attachmentLabel, address: response.value[element].url, clickAction: (link) => {
                        if (attachmentLabel !== "") {
                            window.open(attachmentLabel, "_blank");
                        }
                    }
                };
                tableItems.push(response.value[element]);
            });
            return response.value;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
MapServiceService = __decorate([
    Injectable({
        providedIn: "root"
    })
], MapServiceService);
export { MapServiceService };
